import { Pipe, PipeTransform } from '@angular/core';
import { StatusZawiadomienia } from '@interfaces/stypendia/platforma-administratora/enums/status-zawiadomienia';

@Pipe({
  name: 'statusZawiadomieniaStypendia',
})
export class StatusZawiadomieniaStypendiaPipe implements PipeTransform {
  transform(value: StatusZawiadomienia): string {
    const { Nowe, Zweryfikowano } = StatusZawiadomienia;

    switch (value) {
      case Nowe:
        return 'bg-warning text-secondary';
      case Zweryfikowano:
        return 'bg-success';
      default:
        return 'bg-info';
    }
  }
}
